// @ts-strict-ignore
import { FetchRequestError } from "@lib/errors";
import type { RemoveFirstArgument } from "@lib/typeHelpers";

import type { dashboardApiEndpoints } from "../dashboardApiEndpoints";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { EndpointQueryKey, FilteredDashboardApiEndpointKeys } from "../types";
import type { GetFakeThingProps } from "./types";

/**
 * A fake fetcher function maker, for use in storybook
 *
 * @example
 * export const getFakeDeveloper = (maker: (companyId: string) => Partial<Developer>) =>
 *  getFakeThing({
 *    cacheKey,
 *    baseFakeThing: fakeDeveloper,
 *    maker,
 *  });
 */
export const getFakeFailingGetFetcherFunction = <
  PayloadShape,
  CacheKey extends FilteredDashboardApiEndpointKeys,
  Args extends RemoveFirstArgument<Parameters<(typeof dashboardApiEndpoints)[CacheKey]["GET"]>[0]["queryKey"]>,
>({
  cacheKey,
}: GetFakeThingProps<PayloadShape, CacheKey>): (({
  queryKey: [, ...rest],
  signal,
}: EndpointQueryKey<CacheKey, Args>) => Promise<PayloadShape>) =>
  reactQueryFetcherAdapter(cacheKey, async (): Promise<PayloadShape> => {
    return new Promise((_resolve, reject) =>
      // using 401 will cause the fetch to never retry, which makes the tests more reliable
      setTimeout(() => reject(new FetchRequestError(401, "Failed to fetch")), 500)
    );
  });
